import { http } from '@/api/http';
import type { Paginated } from '@/types/api';
import type { AppNotification, NotificationPreference, NotificationQuery } from './types';

/** Notification endpoints (backend: NotificationsController). */
export const notificationsApi = {
  list: (query: NotificationQuery) =>
    http.getPaginated<AppNotification>('/notifications', { params: query }),

  unreadCount: () => http.get<{ count: number }>('/notifications/unread-count'),

  markRead: (id: string) => http.patch<{ id: string; read: boolean }>(`/notifications/${id}/read`),

  markAllRead: () => http.post<{ updated: number }>('/notifications/read-all'),

  remove: (id: string) => http.del<{ id: string; deleted: boolean }>(`/notifications/${id}`),

  getPreferences: () => http.get<NotificationPreference[]>('/notifications/preferences'),

  setPreference: (body: { type: string; inApp?: boolean; email?: boolean }) =>
    http.post<NotificationPreference>('/notifications/preferences', body),
};

export type NotificationsPage = Paginated<AppNotification>;
